import styled from 'styled-components';

import { Theme } from '@mui/material/styles';
import bgImg from '../../assets/img/background.png';
import logoSvg from '../../assets/img/cnx_logo.svg';

const Container = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  width: 100%;

  > * {
    flex-grow: 1;
    min-height: 100vh;
    z-index: 1;

    @media (min-width: ${({ theme }) => theme.breakpoints.values.md + 'px'}) {
      max-width: 50%;
    }
  }
`;

const LeftContent = styled.div<{ theme: Theme }>`
  background-color: ${({ theme }) => theme.palette.background.special};
  display: flex;
  justify-content: center;
  left: 0;
  padding: ${({ theme }) => `${theme.spacing(16)} ${theme.spacing(6)}`};
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 750px;
  width: 100%;
`;

const RightBackground = styled.div<{ theme: Theme }>`
  background-image: url(${bgImg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  right: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.values.md + 'px'}) {
    display: none;
  }
`;

const CNXLogo = styled.div`
  background-image: url(${logoSvg});
  background-position: left;
  background-repeat: no-repeat;
  background-size: contain;
  height: 35px;
  margin-bottom: ${({ theme }) => theme.spacing(4)};
  width: 100%;
`;

const ChangeLanguageContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: auto;
  > * {
    margin: 4px;
  }
`;

export {
  Container,
  LeftContent,
  ContentContainer,
  RightBackground,
  CNXLogo,
  ChangeLanguageContainer,
};
